import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LangProvider } from "@/contexts/LangContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import CategoryList from "@/pages/CategoryList";
import PostDetail from "@/pages/PostDetail";
import SearchPage from "@/pages/Search";
import { AboutPage, ContactPage, PrivacyPage, DisclaimerPage, TermsPage } from "@/pages/StaticPages";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPostForm from "@/pages/AdminPostForm";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={withLayout(<Home />)} />
            <Route path="/search" element={withLayout(<SearchPage />)} />
            <Route path="/jobs" element={withLayout(<CategoryList />)} />
            <Route path="/results" element={withLayout(<CategoryList />)} />
            <Route path="/admit-card" element={withLayout(<CategoryList />)} />
            <Route path="/answer-key" element={withLayout(<CategoryList />)} />
            <Route path="/syllabus" element={withLayout(<CategoryList />)} />
            <Route path="/admissions" element={withLayout(<CategoryList />)} />
            <Route path="/scholarships" element={withLayout(<CategoryList />)} />
            <Route path="/schemes" element={withLayout(<CategoryList />)} />
            <Route path="/post/:slug" element={withLayout(<PostDetail />)} />
            <Route path="/about" element={withLayout(<AboutPage />)} />
            <Route path="/contact" element={withLayout(<ContactPage />)} />
            <Route path="/privacy" element={withLayout(<PrivacyPage />)} />
            <Route path="/disclaimer" element={withLayout(<DisclaimerPage />)} />
            <Route path="/terms" element={withLayout(<TermsPage />)} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/posts/new" element={<AdminPostForm />} />
            <Route path="/admin/posts/:id" element={<AdminPostForm />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
